/**
 * A React hook that manages the login method state in localStorage based on authentication cookies.
 *
 * This hook checks for the presence of SSO or Basic authentication cookies and updates
 * the login method in localStorage accordingly. It runs once when the component mounts.
 */

import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { AUTH_METHODS, COOKIES, LOCAL_STORAGE_KEYS } from '../constants';

export function useSetLoginMethod() {
  useEffect(() => {
    const isSSO = Boolean(Cookies.get(COOKIES.SSO_AUTH_TOKEN));
    const isBasic = Boolean(Cookies.get(COOKIES.BASIC_AUTH_TOKEN));
    if (isSSO) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.LOGIN_METHOD, AUTH_METHODS.SSO);
    } else if (isBasic) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.LOGIN_METHOD, AUTH_METHODS.BASIC);
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.LOGIN_METHOD);
    }
  }, []);
}
